<div class="appointment-container">
  <div class="stepper-content">
    <div class="header-small-screen">
        <div class="page-header">Online Appointment Booking</div>
    </div>
    <div class="stepper-footer">
      <div class="stepper">
        <app-stepper [steps]="steps" [allowBackNavigation]="true"></app-stepper>
      </div>
    </div>

    <div class="content" #contentContainer>
      <div class="oab-header">
        <div class="page-header">Online Appointment Booking</div>
      </div>
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>

  </div>
  <div class="footer">
    <app-footer [stepRoutes]="stepRoutes" [onSubmit]="handleSubmit" [currentStepInfo]="currentStepInfo"
      [shouldDisableBackButton]="shouldDisableBackButton" [isNextDisabled]="isNextDisabled"
      [validateAndNavigate]="validateAndNavigate">
    </app-footer>
  </div>
</div>

  <div class="footer-large-screen">
    <app-footer [stepRoutes]="stepRoutes" [onSubmit]="handleSubmit" [currentStepInfo]="currentStepInfo"
      [shouldDisableBackButton]="shouldDisableBackButton" [isNextDisabled]="isNextDisabled"
      [validateAndNavigate]="validateAndNavigate">
    </app-footer>
  </div>